<template>
  <span :class="[baseCss]">
    <span
      v-if="text && parseInt(text, 10) !== 0"
      v-html="text"
      :class="['absolute', yPos === 'top' ? 'top-0' : 'bottom-0', xPos === 'left' ? 'left-0' : 'right-0', 'bcq-badge-text', 'text-center', 'inline-block', 'font-semibold', setBgColor(), setTextColor()]" /><slot />
  </span>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Badge',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('badge', ['inline-block', 'select-none', 'relative', 'outline-none'])
    }
  },
  props: {
    text: {
      type: [String, Number],
      required: true
    },
    bgColor: {
      type: String,
      default: 'bcq'
    },
    bgColorLightness: {
      default: null
    },
    color: {
      type: String,
      default: 'white'
    },
    colorLightness: {
      default: null
    },
    yPos: {
      type: String,
      default: 'top',
      validator: value => {
        return ['top', 'bottom'].includes(value)
      }
    },
    xPos: {
      type: String,
      default: 'right',
      validator: value => {
        return ['left', 'right'].includes(value)
      }
    }
  }
}
</script>
<style>
.bcq-badge .bcq-badge-text
{
  min-height: 22px;
  min-width: 22px;
  border-radius: 22px;
  padding: 2px !important;
  line-height: 17px !important;
  font-size: 10px !important;
  transform: scale(.9);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/badge/badge.vue